import type { HealthParameterKey } from './overviewTypes';

const HEALTH_PARAMETER_KEY_SET: ReadonlySet<string> = new Set([
    'bodyWounds',
    'snoutWounds',
    'scaleLoss',
    'skinBleeding',
    'finDamage',
    'emaciation',
    'deformity',
    'deformedJaw',
    'gillLid',
    'cataract',
    'eyeDamage',
    'maturity',
]);

/**
 * Maps Laksvel / DB external keys (snake_case) to overview parameter keys (camelCase).
 * Mirrors backend `HEALTH_PARAMETER_MAPPINGS[].externalKey` → `key`.
 */
const EXTERNAL_KEY_TO_PARAMETER_KEY: Record<string, HealthParameterKey> = {
    body_wounds: 'bodyWounds',
    snout_wounds: 'snoutWounds',
    scale_loss: 'scaleLoss',
    skin_bleeding: 'skinBleeding',
    fin_damage: 'finDamage',
    emaciation: 'emaciation',
    deformity: 'deformity',
    deformed_jaw: 'deformedJaw',
    gill_lid: 'gillLid',
    cataract: 'cataract',
    eye_damage: 'eyeDamage',
    maturity: 'maturity',
};

export function isHealthParameterKey(key: string): key is HealthParameterKey {
    return HEALTH_PARAMETER_KEY_SET.has(key);
}

/** Normalizes API/domain camelCase keys and legacy snake_case external keys to `HealthParameterKey`. */
export function normalizeHealthParameterKey(raw: string): HealthParameterKey | null {
    if (isHealthParameterKey(raw)) {
        return raw;
    }

    return EXTERNAL_KEY_TO_PARAMETER_KEY[raw] ?? null;
}
